"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _Client = _interopRequireDefault(require("./Client"));

var _Payloads = require("./helpers/Payloads");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * An Annotation is a single annotation with or without x/y coordinate data.
 */
var Annotation = /*#__PURE__*/function () {
  /**
   * Initializes with provided asset and raw annotation response.
   * @param   {String}  assetId           asset urn
   * @param   {Object}  annotationObject  annotationObject
   */
  function Annotation(assetId) {
    var annotationObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Annotation);

    this.assetId = assetId;
    this.annotationId = annotationObject.id;
    this.annotationObject = annotationObject;
  }
  /**
   * Helper returns legacy path root if config is in legacy mode.
   *
   * @return  {string}  legacy path root
   */


  _createClass(Annotation, [{
    key: "getPathRoot",
    value: function getPathRoot() {
      return _Client["default"].instance.isACP ? '' : "assets/".concat(this.assetId, "/annots/");
    }
    /**
     * Helper returns legacy annot id or full annot url depending on config.
     *
     * @return  {string}  legacy path root
     */

  }, {
    key: "getAnnotUrl",
    value: function getAnnotUrl() {
      return _Client["default"].instance.isACP ? this.annotationObject.url : this.annotationId;
    }
    /**
     * Peforms an API get for the current annotation.
     *
     * @return  {promise}  The promise resolved as an Annotation model object
     */

  }, {
    key: "get",
    value: function get() {
      return _Client["default"].instance.request(this.assetId, 'annotation.get', this.getAnnotUrl(), 'GET', null, {
        'If-Match': this.annotationObject.etag
      });
    }
    /**
     * Performs an API reply for the current annotation.
     *
     * @param   {string}  commentText      The reply text
     * @param   {json[]}  mentionUserList  The array of mentions (optional)
     *
     * @return  {promise}                  The promise resolved as an Annotation model object
     */

  }, {
    key: "reply",
    value: function reply(commentText, mentionUserList) {
      try {
        var payload = (0, _Payloads.getCommentPayload)(this.annotationId, commentText, null, null, mentionUserList, _Payloads.MOTIVATIONS.REPLY);
        return _Client["default"].instance.request(this.assetId, 'annotation.reply', this.getPathRoot(), 'POST', payload, {});
      } catch (err) {
        console.log(err);
        return Promise.reject(err);
      }
    }
    /**
     * Updates this annoation with fresh comments, coordinates and mentions.
     *
     * @param   {string}  commentText      comment text
     * @param   {json}  coordinates        json payload for noteX,Y and sectionId (optional)
     * @param   {json[]}  mentionUserList  mentions list (optional)
     * @param   {String} nodeIdOverride The id of the node within the asset you wish to reassign the comment to.
     *
     * @return  {promise}                  The promise resolved as an Annotation model object
     */

  }, {
    key: "update",
    value: function update(commentText, coordinates, mentionUserList, nodeIdOverride) {
      var _this = this;

      try {
        // Create a copy of the annotation object.
        var updateAnnotationObject = (0, _lodash["default"])(this.annotationObject); // Update comments

        updateAnnotationObject.bodyValue = commentText; // Remove, and remember nested replies, as the RedHawk API does not support this.

        var replies = [];

        if (updateAnnotationObject.replies) {
          var _updateAnnotationObje = updateAnnotationObject;
          replies = _updateAnnotationObje.replies;
          delete updateAnnotationObject.replies;
        } // Update mentions


        if (mentionUserList && mentionUserList.length > 0) {
          updateAnnotationObject.mentions = mentionUserList;
        } // If ACP, just create a new payload from this now updated source object, carrying forward target updates.


        if (_Client["default"].instance.isACP) {
          // Updates coordinates, and mentions in new payload.
          updateAnnotationObject = (0, _Payloads.getAnnotationPayload)(updateAnnotationObject, nodeIdOverride, true, coordinates);
        } else {
          // Set the target node id or index.
          updateAnnotationObject = (0, _Payloads.setTargetNode)(updateAnnotationObject, nodeIdOverride); // Updates coordinates in old payload.

          updateAnnotationObject = (0, _Payloads.updateCoordinates)(updateAnnotationObject, coordinates, true);
        }

        return new Promise(function (resolve, reject) {
          _Client["default"].instance.request(_this.assetId, 'annotation.update', _this.getAnnotUrl(), 'PUT', updateAnnotationObject, {
            'If-Match': _this.annotationObject.etag
          }).then(function (annotation) {
            // Restore replies
            if (annotation.motivation === _Payloads.MOTIVATIONS.COMMENT) {
              annotation.replies = replies;
            }

            resolve(annotation);
          })["catch"](reject);
        });
      } catch (err) {
        console.log(err);
        return Promise.reject(err);
      }
    }
    /**
     * Deletes this annotation.
     * @returns {promise} null
     */

  }, {
    key: "delete",
    value: function _delete() {
      return _Client["default"].instance.request(this.assetId, 'annotation.delete', "".concat(this.getAnnotUrl(), "?recursive=true"), 'DELETE', null, {
        'If-Match': this.annotationObject.etag
      });
    }
    /**
     * Resolves this annotation.
     *
     * @return  {promise} The promise resolved as an Annotation model object
     */

  }, {
    key: "resolve",
    value: function resolve() {
      return this._perform('annotation.resolve');
    }
    /**
     * Opens this annotation.
     *
     * @return  {promise} The promise resolved as an Annotation model object
     */

  }, {
    key: "open",
    value: function open() {
      return this._perform('annotation.open');
    }
    /**
     * Updates an existing annotation by either: resolving (status back to resolve & collapsing comments),
     *         or opening (status back to open)
     * @param {*} op One of open or resolve operations
     * @returns {Promise} Promise
     */

  }, {
    key: "_perform",
    value: function _perform(op) {
      var _this2 = this;

      try {
        // Create a copy of the annotation object.
        var updateAnnotationObject = (0, _lodash["default"])(this.annotationObject); // Remove nested replies, as the RedHawk API does not support this.

        var replies = [];

        if (updateAnnotationObject.replies) {
          var _updateAnnotationObje2 = updateAnnotationObject;
          replies = _updateAnnotationObje2.replies;
          delete updateAnnotationObject.replies;
        } // Set the status to resolved.


        if (op === 'annotation.resolve') {
          updateAnnotationObject.status = _Payloads.STATUS.RESOLVED;
        } else {
          updateAnnotationObject.status = _Payloads.STATUS.OPEN;
        } // If ACP, create a new payload


        if (_Client["default"].instance.isACP) {
          updateAnnotationObject = (0, _Payloads.getAnnotationPayload)(updateAnnotationObject, null, false, null);
        } else {
          updateAnnotationObject = (0, _Payloads.updateCoordinates)(updateAnnotationObject, null, true);
        } // Update annotation.


        return new Promise(function (resolve, reject) {
          _Client["default"].instance.request(_this2.assetId, op, _this2.getAnnotUrl(), 'PUT', updateAnnotationObject, {
            'If-Match': _this2.annotationObject.etag
          }).then(function (annotation) {
            // Restore replies
            if (annotation.motivation === _Payloads.MOTIVATIONS.COMMENT) {
              annotation.replies = replies;
            }

            resolve(annotation);
          })["catch"](reject);
        });
      } catch (err) {
        console.log(err);
        return Promise.reject(err);
      }
    }
  }]);

  return Annotation;
}();

var _default = Annotation;
exports["default"] = _default;